import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'
import HrbTranslate from '../../language/HrbTranslate';
import "./Pages.scss";

const NextPage = ({ currentPage, maxPage, onSetPage }) => (
    <div className={classnames('next', { 'disabled': currentPage === maxPage })}
        onClick={() => onSetPage(Math.min(maxPage, currentPage + 1))}>
        {currentPage !== maxPage &&
            <a><HrbTranslate text="QueuePage.Labels.Next" /></a>
        }
        {currentPage === maxPage &&
            <HrbTranslate text="QueuePage.Labels.Next" />
        }
        <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 17L9 9L0.999999 0.999999" stroke="#007C10" strokeWidth="2" />
        </svg>

    </div>
)


NextPage.propTypes = {
    currentPage: PropTypes.number.isRequired,
    maxPage: PropTypes.number.isRequired,
    onSetPage: PropTypes.func.isRequired
}

export default NextPage;